import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Sl04DataService {

  private savedPackage: any = null;
  
  constructor() {}

  // Impostare i dati per sl04
  setPackage(packageData: any): void {
    if (!this.savedPackage) {
      this.savedPackage = packageData;  // Salva i dati solo se non sono già salvati
    }
  }

  // Recuperare i dati di sl04
  getPackage(): any {
    return this.savedPackage;  // Ritorna i dati salvati
  }

  // Reset dei dati, se necessario
  resetPackage(): void {
    this.savedPackage = null;
  }
}